<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Реестр начислений</h3>
                <v-card
                        width="400px"
                >
                    <v-card-text>
                        <v-text-field
                                type="date"
                                v-model.trim="date_begin"
                                label="Дата начала"
                        ></v-text-field>
                        <v-text-field
                                type="date"
                                v-model.trim="date_end"
                                label="Дата окончания"
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click.native="downloadReport()"
                    >Сформировать отчет
                    </v-btn>
                </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

export default {
  data () {
    return {
      date_begin: null,
      date_end: null
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    }
  },
  methods: {
    downloadReport () {
      this.$store.dispatch('gis_gmpReports/downloadReportCharge',
        { date_begin: this.date_begin, date_end: this.date_end })
    }
  }
}
</script>
